import DashboardPage from './dashboard.page';

const Dashboard = () => {
  return <DashboardPage queryKey="dashboard" url="/admin/api/dashboard" title="Tableau de bord" />;
};

export default Dashboard;
